import React from 'react';
import { motion } from 'framer-motion';
import type { PaymentStatus } from '@dutchinvoice/types';
import { PaymentStatusBadge } from './PaymentStatusBadge';

const PAYMENT_STATUSES: PaymentStatus[] = ['unpaid', 'paid'];

interface PaymentStatusPopoverProps {
  currentStatus: PaymentStatus;
  onSelect: (status: PaymentStatus) => void;
  onClose: () => void;
}

export const PaymentStatusPopover: React.FC<PaymentStatusPopoverProps> = ({
  currentStatus,
  onSelect,
  onClose,
}) => {
  // Filter out 'unpaid' if current status is 'overdue_reminded'
  const availableStatuses = PAYMENT_STATUSES.filter(status => {
    // Don't allow changing back to 'unpaid' after a reminder was sent
    if (status === 'unpaid' && currentStatus === 'overdue_reminded') {
      return false;
    }
    return true;
  });

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.1 }}
      className="absolute overflow-hidden right-0 mt-2 w-48 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50"
    >
      <div role="menu">
        {availableStatuses.map((status) => (
          <button
            key={status}
            type="button"
            onClick={() => {
              onSelect(status);
              onClose();
            }}
            className={`w-full text-left px-4 py-2 text-sm transition-colors duration-200 ${
              status === currentStatus
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-50'
            }`}
            role="menuitem"
          >
            <PaymentStatusBadge status={status} asChild />
          </button>
        ))}
      </div>
    </motion.div>
  );
}; 